export const loginExpiration = "/sso-web/login";

export const storageKey = {
    locale: "h-locale",
    token: "h-token",
    user: "h-user",
    tenant: "h-tenant",
    companyList: "h-companyList",
    company: "h-company",
    app: "h-app",
    menuList: "h-menuList"
};

export const defaultLocaleValue = "zh-cn";
